import spanishFlag from "assets/img/flags/spanishx24.png"
import englishFlag from "assets/img/flags/englishx24.png"
import frenchFlag from "assets/img/flags/frenchx24.png"

export const languages = [
  {
    id: 1,
    name: "Español",
    icon: spanishFlag,
  },
  {
    id: 2,
    name: "Inglés",
    icon: englishFlag,
  },
  {
    id: 3,
    name: "Francés",
    icon: frenchFlag,
  },
]
